module.exports = __webpack_public_path__ + "static/img/mffl.600d024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mffl.png
// module id = 9+UY
// module chunks = 1